
                            const shader = `precision highp float;

uniform sampler2D tMap;

varying vec2 vUv;

void main() {

	vec2 dUv = vec2(vUv.x, 1. - vUv.y);

	dUv = (dUv - 0.5) * 1.1 + 0.5;

	vec3 color = texture2D(tMap, dUv).rgb;

	float alpha = .3;
	// alpha = 0.;
	alpha *= smoothstep(0., 0.03, vUv.x) * smoothstep(1., 0.97, vUv.x);
	alpha *= smoothstep(0., 0.03, vUv.y) * smoothstep(1., 0.97, vUv.y);

	gl_FragColor = vec4(color, alpha);
}
`;

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = shader;
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        